import React from 'react';

import { Box } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

interface MobileMenuSectionHeaderProps {
  label: string;
}

export const MobileMenuSectionHeader: React.FC<MobileMenuSectionHeaderProps> = ({ label }) => {
  return (
    <Box className="border-y border-od-border-primary bg-od-bg-secondary py-4 pl-6 pr-4">
      <Text as="span" className="text-label-sm text-od-content-tertiary">
        {label}
      </Text>
    </Box>
  );
};
